import { OrderStatus } from "@/models/order/helpers";
import { Order } from "@/models/order/order";
import { replaceLineItems } from "./actions";
import { setAllLineItems } from "./mutations";

export type OrderState = Order;

export type OrderContext = {
  state: OrderState;
  dispatch: (action: OrderActions, payload?: any) => any;
  commit: (mutation: OrderMutations, payload: any) => any;
};

export enum OrderMutations {
  SetLineItem = "setLineItem",
  SetStatus = "setStatus",
  SetShipping = "setShipping",
  SetBilling = "setBilling",
  SetPayment = "setPayment",
  SetContact = "setContact",
  SetOrder = "setOrder",
  ClearOrder = "clearOrder",
  ResetState = "resetState",
  SetAllLineItems = "setAllLineItems",
  SetCustomer = "setCustomer",
  SetCustomerContact = "setCustomerContact",
  SetNotes = "setNotes",
  SetOrderId = "setOrderId",
  EditLineItem = "editLineItem",
  ClearCustomer = "clearCustomer",
  ClearCreatedType = "clearCreatedType",
  // FUPOF-191: draft lifecycle
  SetDraftMeta = "setDraftMeta",
  SetDraftLineIds = "setDraftLineIds",
  SetDriftReport = "setDriftReport",
  SetNetSuiteTranId = "setNetSuiteTranId",
  // FUPOF-209: shipping + tax as NetSuite holds them, from the reload report
  SetNsTotals = "setNsTotals"
}

export enum OrderActions {
  AddLineItem = "addLineItem",
  AddOrderStatus = "addOrderStatus",
  AddShipping = "addShipping",
  AddBilling = "addBilling",
  AddPayment = "addPayment",
  AddContact = "addContact",
  AddOrder = "addOrder",
  AddNotes = "addNotes",
  AddOrderId = "addOrderId",
  ReplaceLineItems = "replaceLineItems",
  ApplyQuoteMultiplier = "applyQuoteMultiplier",
  AssignCustomer = "assignCustomer",
  ClearOrder = "clearOrder",
  EditLineItem = "editLineItem",
  ClearCustomer = "clearCustomer",
  ClearCreatedType = "clearCreatedType",
  ResetForUserChange = "resetForUserChange",
  // FUPOF-191: draft lifecycle
  SaveDraft = "saveDraft",
  LoadDraft = "loadDraft",
  DeleteDraft = "deleteDraft",
  ReloadFromNs = "reloadFromNs",
  ClearDriftReport = "clearDriftReport",
  MarkAsDuplicate = "markAsDuplicate",
  ApplySubmittedDraft = "applySubmittedDraft",
  SetNetSuiteTranId = "setNetSuiteTranId"
}

export enum OrderGetters {
  GetOrder = "getOrder",
  GetOrderItems = "getOrderItems",
  GetAssignedCustomer = "getAssignedCustomer",
  GetDriftReport = "getDriftReport"
}
